<template lang="pug">
div
  md-button.md-raised(type="button" @click="addDocumento()") Agregar Documento
  form(v-if="formData" @submit="submit($event, 'documentos', !showSaveButton)")
    div(v-if="showSaveButton" v-for="(v, index) in $v.formData.$each.$iter", :key="'documentos-' + index")
      div(v-if="v && (!isNullOrUndefined(v.link.$model) && !isNullOrUndefined(v.name.$model))")
        ButtonWithAlertDialog(
          title="Eliminar documento"
          message="¿ Está seguro que desea eliminar este documento ?"
          @on-confirm="deleteDocumento(index)"
        ) Eliminar Documento
        h2 Documento Nº {{ parseInt(index) + 1 }}
        md-field(:class="getValidationClass(`formData.$each.${index}.name`)", md-clearable)
          label Nombre del documento
          md-input(v-model="v.name.$model")
          span.md-error(v-if="!v.name.required") Requerido
        md-field(:class="getValidationClass(`formData.$each.${index}.link`)", md-clearable)
          label URL del documento
          md-input(v-model="v.link.$model")
          span.md-error(v-if="!v.link.required") Requerido
        md-divider

    md-button.md-raised.md-primary(v-show="!isCreateView && showSaveButton" type="submit" ref="saveButton") Guardar
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { clone } from '@/utils/form.js'
import { hasData } from '@/utils/object.js'
import projectFormMixin from '@/mixins/project-form.js'

const initValue = {
  name: '',
  link: ''
}

export default {
  mixins: [ projectFormMixin ],
  props: {
    isCreateView: {
      type: Boolean,
      default: false
    },
    customValidations: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    showSaveButton: false
  }),
  validations () {
    return {
      formData: {
        $each: {
          name: {
            required
          },
          link: {
            required
          },
          ...this.customValidations
        }
      }
    }
  },
  methods: {
    addDocumento () {
      if (!this.formData) this.formData = []
      this.formData.push(clone(initValue))
      this.showSaveButton = true
    },
    deleteDocumento (index) {
      if (index !== null) {
        this.formData.splice(index, 1)
        if (!(this.formData && this.formData.length)) {
          this.showSaveButton = false
        }
      }
    },
    initDataWhenValuePropIsAssignedFirstTime (value) {
      if (hasData(value)) {
        this.showSaveButton = true
      } else {
        this.showSaveButton = false
      }
    },
    isNullOrUndefined (val) {
      return val === null || val === undefined
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/edit-project-form-style'
</style>
